import React from 'react'
import './website-inquiry-card-modal-2023.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../../AdminTasks/adminTaskUtils'
import TaskCardSettingBar from '../../TaskCardModal2023/TaskCardSettingBar/TaskCardSettingBar'
import LooksLikeYouAreDonePopup from '../../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'
import WebsiteInquiryCallSwitch from './WebsiteInquryCallSwitch/WebsiteInquiryCallSwitch'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const WebsiteInquiryCardModal2023 = ({openWorkflowModal2023, setOpenWorkflowModal2023, setWorkflows, setShowNotes, closeTheStudentOnboardingModal}) => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    const [showDescription, setShowDescription] = React.useState(false)
    React.useEffect(() => taskCardAnimateIn('website-inquiry-card-modal-2023__wrapper', 'website-inquiry-card-modal-2023'), [])
    React.useEffect(() => setTheTabs())

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: ''})
    }

    const setTheTabs = () => {
        if(document.getElementById('modal-view-tasks') && document.getElementById('modal-view-description')) {
            if(showDescription === false) {
                document.getElementById('modal-view-tasks').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-tasks').style.color = "#000"
                document.getElementById('modal-view-description').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.color = "rgb(146, 146, 146)"
            } else {
                document.getElementById('modal-view-tasks').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-tasks').style.color = "rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-description').style.color = "#000"
            }
        }
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('website-inquiry-card-modal-2023__wrapper', 'website-inquiry-card-modal-2023')
        axios.put(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, openWorkflowModal2023, myHeader)
        .then((res) => {
            closeTheStudentOnboardingModal(res.data)
            setWorkflows(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const deleteAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('website-inquiry-card-modal-2023__wrapper', 'website-inquiry-card-modal-2023')
        axios.delete(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, myHeader)
        .then((res) => {
            setWorkflows(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const notesAutoReset = (theValue) => {
        let noteId = "website-inquiry-card-modal-2023__desc-details"
        if(theValue === 'Notes...') {
            document.getElementById(noteId).value = ''
        }
    }

    const changeAlarm = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, todoAlarm: b})
    }
    const changeHaveBeenCalledSwitch = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, theyHaveBeenCalled: b})
    }

    return(
        <div className='website-inquiry-card-modal-2023__wrapper' id='website-inquiry-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'website-inquiry-card-modal-2023__wrapper' && (openWorkflowModal2023.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setIsPopupOpen(true))}>
            {isPopupOpen && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='website-inquiry-card-modal-2023' id='website-inquiry-card-modal-2023'>
                <input className='website-inquiry-card-modal-2023__task-name' value={openWorkflowModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openWorkflowModal2023} setOpenModal2023={setOpenWorkflowModal2023} />
                <div className="website-inquiry-card-modal-2023__two-sections-divider">
                    <div className="website-inquiry-card-modal-2023__modal-view-tabs" id="modal-view-tasks" onClick={() => setShowDescription(false)}>Tasks</div>
                    <div className="website-inquiry-card-modal-2023__modal-view-tabs" id="modal-view-description" onClick={() => setShowDescription(true)}>Inquiry Message</div>
                </div>
                {showDescription ?
                <textarea className="website-inquiry-card-modal-2023__desc-details" placeholder="Write notes here..." id="website-inquiry-card-modal-2023__desc-details" value={openWorkflowModal2023.todoDescription} onClick={(e) => notesAutoReset(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoDescription: e.target.value})}/>
                :
                <div className='website-inquiry-card-modal-2023__subtask__wrapper'>
                    {openWorkflowModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setOpenWorkflowModal2023} />)}
                    <div className='website-inquiry-card-modal-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...openWorkflowModal2023, todoSubtasks: [...openWorkflowModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                    <div className='website-inquiry-card-modal__courtney-call-alarm__switch-wrapper'>
                        <WebsiteInquiryCallSwitch label={'Have Courtney Call:'} input={openWorkflowModal2023.todoAlarm} setToggle={changeAlarm} />
                        <WebsiteInquiryCallSwitch label={'Called:'} input={openWorkflowModal2023.theyHaveBeenCalled} setToggle={changeHaveBeenCalledSwitch} />
                    </div>
                </div>
                }
            </div>
        </div>
    )
}
export default WebsiteInquiryCardModal2023